function setCookie(name, value, minutes) {
  let expires = '';
  if (minutes) {
    const date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000)); // Převod minut na milisekundy
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

function viewport() {
  var e = window, a = 'inner';
  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return {width: e[a + 'Width'], height: e[a + 'Height']};
}

jQuery(document).ready(function ($) {

  var breakpointMobile = 767;

  if ($("[data-fancybox]").length) {
    Fancybox.bind("[data-fancybox]", {
      infinite: true,
      Image: {
        zoom: false,
      },
    });
  }

  $('form.search').on("submit", function () {
    if ($("form.search input[type=search]").val().length < 2) {
      return false;
    }
  });

  $('.header__search').on("click", function () {
    $(".header__box").toggleClass("search-is-open");
    return false;
  });

  function inputPCSinit() {
    $("input[name=pcs]").unbind("change").on("change", function () {
      var allowDelete = false;
      if ($(this).hasClass("allowDelete")) {
        allowDelete = true;
      }
      var fixedValue = parseInt($(this).val());

      if ((fixedValue <= 0) || (isNaN(fixedValue))) {
        if (allowDelete) {
          fixedValue = 0;
        } else {
          fixedValue = 1;
        }
      } else if (fixedValue >= 100) {
        fixedValue = 99;
      }
      $(this).val(fixedValue);

      if ($(".cart-list").length) {
        $(".cart-list .button").addClass("disabled");
        var productID = $(this).closest(".item").data("product-id");
        var productVariant = $(this).closest(".item").data("product-variant");
        var productVariantCode = $(this).closest(".item").data("product-variant-code");
        $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .cart-list-item-data-action-price").addClass("disabled");
        if (fixedValue >= 1) {
          $(".cart-summary-price").addClass("disabled");
          $.ajax({
            type: 'post',
            url: jsvariables.ajaxurl,
            data: {
              action: "changePCS",
              productID: productID,
              productVariant: productVariant,
              productAmount: fixedValue
            },
            success: function (response) {
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .prices").removeClass("disabled");
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .price_without_vat").html(response.data.product_prices.without_vat);
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .price_with_vat").html(response.data.product_prices.with_vat);

              $(".header__cart .cart-counter").text(response.data.count);
              setCookie('cart-counter', response.data.count, 30);

              $(".cart-summary-price").html(response.data.price).removeClass("disabled");
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .cart-list-item-data-action-price").removeClass("disabled");

              $(".cart-summary-price-with-vat").html(response.data.prices.with_vat);
              $(".cart-summary-price-without-vat").html(response.data.prices.without_vat);

              $(".cart-list .button").removeClass("disabled");
            }
          });
        } else {
          // $.ajax({
          //   type: 'post',
          //   url: jsvariables.ajaxurl,
          //   data: {
          //     action: "removeFromCart",
          //     productID: productID,
          //     productVariant: productVariant
          //   },
          //   success: function (response) {
          //     $(".cart-counter").text(response.data.count);
          //   }
          // });
        }
      }
    });

    $(".quantity button, .quantity .button").unbind("click").on("click", function () {
      if ($(this).hasClass("disabled")) {
        return false;
      }
      var input = $(this).closest(".quantity").find("input[name=pcs]");
      var allowDelete = false;
      if (input.hasClass("allowDelete")) {
        allowDelete = true;
      }
      if ($(this).hasClass("plus")) {
        var fixedValue = parseInt(input.val()) + 1;
      } else if ($(this).hasClass("minus")) {
        var fixedValue = parseInt(input.val()) - 1;
      }

      if ((fixedValue <= 0) || (isNaN(fixedValue))) {
        if (allowDelete) {
          fixedValue = 0;
        } else {
          fixedValue = 1;
        }
      } else if (fixedValue >= 100) {
        fixedValue = 99;
      }
      input.val(fixedValue);

      if ($(".cart-list").length) {
        $(".cart-list .button").addClass("disabled");
        var productID = $(this).closest(".item").data("product-id");
        var productVariant = $(this).closest(".item").data("product-variant");
        var productVariantCode = $(this).closest(".item").data("product-variant-code");
        $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .cart-list-item-data-action-price").addClass("disabled");
        if (fixedValue >= 1) {
          $(".cart-summary-price").addClass("disabled");
          $.ajax({
            type: 'post',
            url: jsvariables.ajaxurl,
            data: {
              action: "changePCS",
              productID: productID,
              productVariant: productVariant,
              productAmount: fixedValue
            },
            success: function (response) {
              $(".cart-list .input--options i").removeClass("disabled");
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .prices").removeClass("disabled");
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .price_without_vat").html(response.data.product_prices.without_vat);
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .price_with_vat").html(response.data.product_prices.with_vat);

              $(".header__cart .cart-counter").text(response.data.count);
              setCookie('cart-counter', response.data.count, 30);

              $(".cart-summary-price").html(response.data.price).removeClass("disabled");
              $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "] .cart-list-item-data-action-price").removeClass("disabled");

              $(".cart-summary-price-with-vat").html(response.data.prices.with_vat);
              $(".cart-summary-price-without-vat").html(response.data.prices.without_vat);

              $(".cart-list .button").removeClass("disabled");
            }
          });
        } else {
          // $.ajax({
          //   type: 'post',
          //   url: jsvariables.ajaxurl,
          //   data: {
          //     action: "removeFromCart",
          //     productID: productID,
          //     productVariant: productVariant
          //   },
          //   success: function (response) {
          //     $(".cart-counter").text(response.data.count);
          //     /* Only for menu products */
          //     reloadMenuSummary();
          //   }
          // });
        }
      }

    });
  }

  inputPCSinit();

  $(".cart-list-item-data-delete").on("click", function () {
    var productID = $(this).closest(".item").data("product-id");
    var productVariant = $(this).closest(".item").data("product-variant");
    var productVariantCode = $(this).closest(".item").data("product-variant-code");
    $(this).closest(".item").addClass("disabled");
    $(".cart-summary-price").addClass("disabled");
    $.ajax({
      type: 'post',
      url: jsvariables.ajaxurl,
      data: {
        action: "removeFromCart",
        productID: productID,
        productVariant: productVariant
      },
      success: function (response) {
        $(".cart-counter").text(response.data.count);
        setCookie('cart-counter', response.data.count, 30);

        $(".cart-summary-price").removeClass("disabled");
        if (response.data.count == 0) {
          $(".cart").hide();
          $(".product-banner ").hide();
          $("#empty").fadeIn();
          $(".header__cart").removeClass("active");
          $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "]").hide();
        } else {
          $(".cart-list-item[data-product-id=" + productID + "][data-product-variant-code=" + productVariantCode + "]").fadeOut(200);
          $(".cart-summary-price-with-vat").html(response.data.prices.with_vat);
          $(".cart-summary-price-without-vat").html(response.data.prices.without_vat);
        }
      }
    });
    return false;
  });

  function labelsInit() {
    if ($(".input .label").length) {
      $(".input .label").each(function () {
        if ($(this).closest(".input").hasClass("textarea")) {
          var value = $(this).closest(".input").find("textarea").val();
        } else {
          var value = $(this).closest(".input").find("input").val();
        }
        if (value != "") {
          $(this).fadeIn(200);
        }
      });
      $(".input input, .input textarea").on("keyup", function () {
        var value = $(this).val();
        if (value.length == 0) {
          $(this).closest(".input").find(".label").fadeOut(200);
        } else {
          $(this).closest(".input").find(".label").fadeIn(200);
        }
      });
    }
  }

  labelsInit();

  var contactForm = $("#contactForm");
  if (contactForm.length) {
    contactForm.validate({
      submitHandler: function (form) {
        // $(form).find(".error[data-type=checkbox_cf_gdpr]").hide();
        // if ($(form).find("input[name=checkbox_cf_gdpr]").is(":checked")) {
        $(form).addClass("sending");
        $(form).find(".btn")
          .prop("disabled", "disabled")
          .addClass("active");
        var height = $(form).outerHeight();
        var data = $(form).serialize();
        $.ajax({
          type: 'post',
          url: jsvariables.ajaxurl,
          data: data + "&action=contactForm",
          success: function (response) {
            contactForm.hide().next()
              .css("height", height + "px")
              .html(response.data.html)
              .css("display", "flex")
              .hide()
              .fadeIn(200);
          }
        });
        // } else {
        //     $(form).find(".error[data-type=checkbox_cf_gdpr]").fadeIn();
        //     return false;
        // }
      }
    });
  }

  var cartForm = $("#cartForm");
  if (cartForm.length) {
    cartForm.validate({
      submitHandler: function (form) {
        $(form).addClass("sending");
        $(form).find(".btn")
          .prop("disabled", "disabled")
        return true;
      }
    });
  }

  $('.footer__title.has-child').on("click", function (e) {
    if (viewport().width <= breakpointMobile) {
      var clicked = $(e.target);
      if (clicked.is('a') || clicked.parents().is('a')) {
        return;
      } else {
        $(this).parent()
          .toggleClass("is-open");
        $(this).next()
          .slideToggle(200);
        return false;
      }
    }
  });

  function productFilter(currentPage) {

    $(".loadContent .loaderBox").addClass("active");

    var data = $("#productFilter").serialize() + '&currentPage=' + currentPage;

    $.ajax({
      type: 'post',
      url: jsvariables.ajaxurl,
      data: data,
      success: function (response) {

        $(".loadContent .loaderBox").removeClass("active");

        window.history.pushState(null, null, response.data.url);

        $(".loadContent .products-list__list").html(response.data.html);

        $(".pager").html(response.data.pagination);

        addToCartInit();

      }
    });
  }

  $("#productFilter input[type=radio]").on("change", function () {
    productFilter(1);
  });

  function changePriceBySelectedWeight() {
    var weightSelect = $(".product-detail [name=weight]");
    var priceWithVat = weightSelect.find(':selected').data('priceWithVat');
    var priceWithoutVat = weightSelect.find(':selected').data('priceWithoutVat');
    $(".product-detail__prices .price-with-vat").html(decodeURIComponent(priceWithVat));
    $(".product-detail__prices .price-without-vat").html(decodeURIComponent(priceWithoutVat));

    if ($(".product-detail [name=color]").length) {
      var weights = $(".product-detail [name=color]:checked").data("weight");
      var ids = $(".product-detail [name=color]:checked").data("ids");
      var stocks = $(".product-detail [name=color]:checked").data("stock");
      var stock_statuses = $(".product-detail [name=color]:checked").data("stockStatus");
      $.each(weights, function (index, weight) {
        var option = $(".product-detail [name=weight]").find("[data-weight='" + weight + "']");
        option.attr("data-ids", JSON.stringify([ids[index]]));
        option.attr("data-stock", JSON.stringify([stocks[index]]));
        option.attr("data-stock-status", JSON.stringify([stock_statuses[index]]));
      });
    }
    var variantsIDs = weightSelect.find(':selected').attr('data-ids');
    $(".product-toolbar .addToCart").attr("data-variant", variantsIDs);

    var stock = JSON.parse(weightSelect.find(':selected').attr('data-stock'));
    var stockStatus = parseInt(JSON.parse(weightSelect.find(':selected').attr('data-stock-status')));
    $(".product-toolbar .stock-availability").removeClass("stock-availability--secondary stock-availability--tertiary").html(decodeURIComponent(stock));
    if (stockStatus == 0 || stockStatus == 1) {
      $(".product-toolbar .stock-availability").addClass("stock-availability--secondary");
    }else if (stockStatus == -1) {
      $(".product-toolbar .stock-availability").addClass("stock-availability--tertiary");
    }
  }

  $(".product-detail [name=color]").on("change", function () {
    var weights = $(this).data("weight");
    var select = $(".product-detail [name=weight]");
    select.find("option").prop("disabled", true);
    $.each(weights, function (index, weight) {
      var option = select.find("[data-weight='" + weight + "']");
      option.prop("disabled", false);
      if (index == 0) {
        select.val(weight);
        changePriceBySelectedWeight();
      }
    });
  });

  $(".product-detail [name=weight]").on("change", function () {
    changePriceBySelectedWeight();
  });

  $(".swatch__item").on("click", function () {
    var parentEl = $(this).closest(".swatch-wrapper");
    var activeText = parentEl.data("text");
    var color = $(this).data("id");
    $(".product-detail [name=shade]").val(color);
    parentEl.find(".swatch__item").removeClass("active");
    $(this)
      .addClass("active")
      .find(".swatch__top span").text(activeText);

    $.ajax({
      type: 'post',
      url: jsvariables.ajaxurl,
      data: {
        action: "saveSamplerColor",
        color: color,
      },
      success: function (response) {

      }
    });
    $(".popup[data-id=sampler]").removeClass("active");
    $("body").removeClass("fixed-mobile");
    return false;
  });

  $('.popup').on("mousedown", function (e) {
    var clicked = $(e.target);
    if (clicked.is('.box') || clicked.parents().is('.box')) {
      return;
    } else {
      $(this).closest(".popup").removeClass("active");
      $("body").removeClass("fixed-mobile");
    }
  });

  $(".open-popup").on("click", function () {
    const id = $(this).data("id");
    $(".popup[data-id=" + id + "]").addClass("active");
    if (id == "sampler") {
      const sampler = $(this).data("sampler");
      $(".popup[data-id=" + id + "] .swatch").hide();
      $(".popup[data-id=" + id + "] .swatch[data-id='" + sampler + "']").show();
      $("body").addClass("fixed-mobile");
    }
    return false;
  });

  $(".popup .close, .popup [data-close]").on("click", function () {
    $(this).closest(".popup").removeClass("active");
    $("body").removeClass("fixed-mobile");
  });

  function addToCartInit() {
    $("a.addToCart").unbind("click").on("click", function () {
      var productID = $(this).data("id");
      var productVariant = JSON.parse($(this).attr("data-variant"));
      var productAmount = $(this).closest(".product-toolbar").find("input[name=pcs]").val();
      if (typeof productAmount === 'undefined') {
        productAmount = 1;
      }
      var productVariantName = [];
      var shadeEl = $(this).closest(".product-detail").find("[name=shade]");
      if (shadeEl.length) {
        productVariantName[0] = shadeEl.val();
      }
      var colorEl = $(this).closest(".product-detail").find("[name=color]:checked");
      if (colorEl.length) {
        productVariantName[1] = colorEl.val()
      }
      var weightEl = $(this).closest(".product-detail").find("[name=weight]");
      if (weightEl.length) {
        productVariantName[2] = weightEl.val()
      }

      addToCart(productID, productAmount, productVariant, productVariantName);
      return false;
    });
  }

  function addToCart(productID, productAmount, productVariant, productVariantName) {
    $.ajax({
      type: 'post',
      url: jsvariables.ajaxurl,
      data: {
        action: "addToCart",
        productID: productID,
        productAmount: productAmount,
        productVariant: productVariant,
        productVariantName: productVariantName
      },
      success: function (response) {
        $(".header__cart").addClass("active");
        $(".header__cart .cart-counter").text(response.data.count);
        setCookie('cart-counter', response.data.count, 30);
        setTimeout(function () {
          $(".header__cart .cart-note").fadeIn(300).addClass("active");

          function hidecartNote() {
            $(".header__cart .cart-note").fadeOut(300).removeClass("active");
          }

          setTimeout(hidecartNote, 5000);
        }, 0);

      }

    });
  }

  addToCartInit();

  $(".product-detail__thumbs a").hover(
    function () {
      var i = $(this).index();
      $(".product-detail-hover-gallery").addClass("active");
      $(".product-detail-hover-gallery img")
        .removeClass("active")
        .eq(i).addClass("active");
    }
  );
  $(".product-detail__thumbs").hover(
    function () {

    },
    function () {
      $(".product-detail-hover-gallery").removeClass("active");
      $(".product-detail-hover-gallery img").removeClass("active");
    }
  );

  if (getCookie('cart-counter')) {
    $(".header__cart .cart-counter").text(getCookie('cart-counter'));
    $(".header__cart").addClass("active");
  }

});

const ELEMENTS = '.js-ToggleBodyClass'

class ToggleBodyClass {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    if (!this.elements) {
      return false
    }

    this.elements.forEach(el => {
      el.addEventListener('click', this.toggle, false)
    })
  }

  toggle = (e) => {
    const el = e.currentTarget
    const classes = el.getAttribute('data-toggle')
    const classesRemove = el.getAttribute('data-remove')

    if (classesRemove) {
      classesRemove.split(" ").forEach(className => {
        document.body.classList.remove(className)
      })
    } else {
      classes.split(" ").forEach(className => {
        document.body.classList.toggle(className)
      })
    }

  }
}

new ToggleBodyClass()

function toggleList(element) {
  var footerCol = element.parentNode;
  footerCol.classList.toggle("is-open");
}

var titles = document.querySelectorAll('.js-categories-opener');
titles.forEach(function (title) {
  title.addEventListener('click', function () {
    toggleList(this);
  });
});

const START_OFFSET = 10;
const START_CLASS = "is-scrolled";
const BOTTOM_OFFSET = 10;
const BOTTOM_CLASS = "is-scrolled-bottom";

const UP_DOWN_CLASSES = false;
const UP_CLASS = "scrolling-up";
const DOWN_CLASS = "scrolling-down";

class ScrollClass {
  constructor() {
    document.addEventListener("scroll", this.scrollHandler, {passive: true});

    this.scrollHandler();
  }

  scrollHandler = () => {
    const top = document.documentElement.scrollTop;

    document.body.classList.toggle(START_CLASS, top >= START_OFFSET);
    document.body.classList.toggle(
      BOTTOM_CLASS,
      window.innerHeight + top >= document.body.offsetHeight - BOTTOM_OFFSET
    );

    if (UP_DOWN_CLASSES) {
      if (this.oldScroll > top) {
        document.body.classList.add(UP_CLASS)
        document.body.classList.remove(DOWN_CLASS);
      } else {
        document.body.classList.add(DOWN_CLASS)
        document.body.classList.remove(UP_CLASS);
      }
    }

    this.oldScroll = top;

  };
}

new ScrollClass();
